// DARKDEV: animate a brush mask over the unchanged original artwork.
if (!customElements.get('darkdev-autograph')) {
  customElements.define('darkdev-autograph', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.ink = this.querySelector('image');
      this.strokes = [...this.querySelectorAll('mask path')];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.restore = () => this.showOriginal();
      this.motion.addEventListener('change', this.restore);
      if (this.motion.matches || !this.ink || !this.strokes.length ||
          !('IntersectionObserver' in window) || !('requestAnimationFrame' in window)) return;
      // No mask in the HTML: the artwork remains visible without JavaScript.
      this.prepare();
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.replay();
          this.observer.disconnect();
        }
      }, {threshold: .65});
      this.observer.observe(this);
    }
    prepare() {
      this.strokes.forEach(path => {
        const length = path.getTotalLength();
        path.dataset.inkLength = String(length);
        path.style.strokeDasharray = `${length} ${length}`;
        path.style.strokeDashoffset = String(length);
      });
      this.ink.setAttribute('mask', `url(#${this.dataset.writingMask})`);
    }
    showOriginal() {
      cancelAnimationFrame(this.frame || 0);
      this.frame = 0;
      this.ink?.removeAttribute('mask');
      this.removeAttribute('data-writing');
      this.removeAttribute('data-ink-step');
    }
    replay() {
      this.showOriginal();
      if (this.motion.matches || document.body.dataset.darkdevDisableWriting === 'true' ||
          !this.strokes.length || !('requestAnimationFrame' in window)) return;
      this.prepare();
      this.setAttribute('data-writing', 'true');
      let delay = 80;
      const timeline = this.strokes.map(path => {
        const duration = Number(path.dataset.ink) * .35;
        const stroke = {path, duration, delay, length: Number(path.dataset.inkLength)};
        delay += duration + 15;
        return stroke;
      });
      const started = performance.now();
      const paint = now => {
        const elapsed = now - started;
        let completed = 0;
        timeline.forEach(({path, duration, delay, length}) => {
          const progress = Math.max(0, Math.min(1, (elapsed - delay) / duration));
          const offset = String(length * (1 - progress));
          if (path.style.strokeDashoffset !== offset) path.style.strokeDashoffset = offset;
          if (progress === 1) completed++;
        });
        this.setAttribute('data-ink-step', String(completed));
        if (completed === timeline.length) this.showOriginal();
        else this.frame = requestAnimationFrame(paint);
      };
      this.frame = requestAnimationFrame(paint);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.restore);
      this.showOriginal();
      this.ready = false;
    }
  });
}
